export default {
  glossaryWikiNaturalIdState(state) {
    return state.naturalId;
  },
  glossaryWikiDataState(state) {
    return state.data;
  },
};
